import { selectChainsReportSearchSection } from '../select-chains-search-section';
import { createSelector } from '@reduxjs/toolkit';

export const selectChainsSearchSelectedRegionName = createSelector(
    selectChainsReportSearchSection,
    (chains) => chains.selectedRegion,
);
